module.exports = __webpack_public_path__ + "04_veryshort_gold.dad41063.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_veryshort_gold.png
// module id = vZZh
// module chunks = 0